import { useState } from "react";
import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import logo from "../../assets/kangaroo/logoSmartKampus.png";
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Container,
  Card,
  CardBody,
} from "reactstrap";
import { Formik } from "formik";
import LoginService from "../../services/LoginService";
import { Eye, EyeOff, ShieldCheck, UserPlus } from "lucide-react";

const Register = () => {
  const navigate = useNavigate();
  const [passwordShow, setPasswordShow] = useState(false);

  const registerValidationSchema = Yup.object().shape({
    fullName: Yup.string()
      .min(3, "Too short!")
      .required("Full Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().required("Phone is required"),
    password: Yup.string().min(6, "Min 6 characters").required("Required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Required"),
  });

  const handleRegister = async (values) => {
    try {
      await LoginService.register({
        fullName: values.fullName,
        email: values.email,
        phone: values.phone,
        password: values.password,
        userFrom: 3,
      });
      toast.success(
        "Your registration has been completed successfully. It is currently under review by the admin. You will receive an email once your account is approved. You will be able to log in only after approval.",
        {
          duration: 60000, // 40 seconds
          position: "top-center", // optional, default is top-right
        },
      );
      navigate("/login");
    } catch (error) {
      toast.error(error?.response?.data || "Registration failed.");
    }
  };

  return (
    <Container fluid className="vh-100 overflow-hidden p-0 bg-light">
      <Row className="g-0 h-100">
        {/* LEFT PANEL */}
         <Col
          lg={7}
          className="d-none d-lg-flex flex-column justify-content-center align-items-center text-center text-white p-5"
          style={{
            background: "linear-gradient(135deg, #764ba2 0%, #c77dff 100%)",
          }}
        >
          <img
            src={logo}
            alt="Kangaroo Logo"
            className="img-fluid mb-4"
            style={{ maxHeight: "140px" }}
          />

          {/* <div>
            <h1
              className="m-0 p-0 font-level-4  text-uppercase"
              style={{ letterSpacing: "3px", lineHeight: "1" }}
            >
              Start Smart
            </h1>

            <h1
              className="font-level-4 fw-bold text-uppercase mt-0"
              style={{
                letterSpacing: "4px",
                color: "#7E1790",
                lineHeight: "1",
              }}
            >
              With Kangaroo
            </h1>
          </div> */}
          <hr
            className="w-25 my-1"
            style={{
              backgroundColor: "#F6921E",
              height: "3px",
              border: "none",
              opacity: 1
            }}
          />

          <Card className="bg-transparent border-0 w-75">
            <CardBody className="p-4">
              <h3 className="fw-bold mb-3 text-white">
                Where You Start Smart,Learn Continously, and Deliver with Confidence
              </h3>
              {/* <p className="fs-5 mb-0 text-white">
               Where Structured Information Empowers You To Start Smart and Deliver with Precision.
              </p> */}
            </CardBody>
          </Card>
        </Col>

        {/* RIGHT PANEL */}
        <Col xs={12} lg={5} className="d-flex flex-column h-100 bg-white">
          {/* Form Container */}
          <div className="flex-grow-1 d-flex align-items-center justify-content-center p-3 p-md-5 overflow-hidden">
            <Card
              className="border-0 w-100 shadow-none"
              style={{ maxWidth: "450px" }}
            >
              <CardBody className="p-0">
                {/* Header */}
                <div className="text-center mb-4">
                  <div
                    className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "60px",
                      height: "60px",
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    }}
                  >
                    <UserPlus className="text-white" size={28} />
                  </div>
                  <h2 className="fw-bold mb-1 text-dark">Register</h2>
                  <p className="text-muted small">
                    Enter your details to create an account
                  </p>
                </div>

                {/* Scrollable Form Area */}
                <div
                  className="px-1"
                  style={{
                    maxHeight: "65vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <Formik
                    initialValues={{
                      fullName: "",
                      email: "",
                      phone: "",
                      password: "",
                      confirmPassword: "",
                    }}
                    validationSchema={registerValidationSchema}
                    onSubmit={handleRegister}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <Form onSubmit={handleSubmit} noValidate className="pe-2">
                        <FormGroup className="form-floating mb-3">
                          <Input
                            id="fullName"
                            name="fullName"
                            placeholder="Full Name"
                            value={values.fullName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            invalid={touched.fullName && !!errors.fullName}
                            className="rounded-3 border-2 shadow-sm"
                          />
                          <Label for="fullName">Full Name</Label>
                          <FormFeedback>{errors.fullName}</FormFeedback>
                        </FormGroup>

                        <FormGroup className="form-floating mb-3">
                          <Input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            invalid={touched.email && !!errors.email}
                            className="rounded-3 border-2 shadow-sm"
                          />
                          <Label for="email">Email address</Label>
                          <FormFeedback>{errors.email}</FormFeedback>
                        </FormGroup>

                        <FormGroup className="form-floating mb-3">
                          <Input
                            id="phone"
                            name="phone"
                            placeholder="Phone"
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            invalid={touched.phone && !!errors.phone}
                            className="rounded-3 border-2 shadow-sm"
                          />
                          <Label for="phone">Phone Number</Label>
                          <FormFeedback>{errors.phone}</FormFeedback>
                        </FormGroup>

                        <FormGroup className="form-floating mb-3 position-relative">
                          <Input
                            type={passwordShow ? "text" : "password"}
                            id="password"
                            name="password"
                            placeholder="Password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            invalid={touched.password && !!errors.password}
                            className="rounded-3 border-2 shadow-sm"
                          />
                          <Label for="password">Password</Label>
                          <Button
                            color="link"
                            className="position-absolute top-50 end-0 translate-middle-y text-muted border-0 bg-transparent p-0 pe-3"
                            onClick={() => setPasswordShow(!passwordShow)}
                            type="button"
                            style={{ zIndex: 10, textDecoration: "none" }}
                          >
                            {passwordShow ? (
                              <EyeOff size={18} />
                            ) : (
                              <Eye size={18} />
                            )}
                          </Button>
                          <FormFeedback>{errors.password}</FormFeedback>
                        </FormGroup>

                        <FormGroup className="form-floating mb-4">
                          <Input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Confirm"
                            value={values.confirmPassword}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            invalid={
                              touched.confirmPassword &&
                              !!errors.confirmPassword
                            }
                            className="rounded-3 border-2 shadow-sm"
                          />
                          <Label for="confirmPassword">Confirm Password</Label>
                          <FormFeedback>{errors.confirmPassword}</FormFeedback>
                        </FormGroup>

                        <Button
                          type="submit"
                          disabled={isSubmitting}
                          className="w-100 py-2 fw-bold shadow-sm"
                          style={{
                            background:
                              "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            border: "none",
                            height: "50px",
                            borderRadius: "10px",
                          }}
                        >
                          {isSubmitting ? (
                            <span className="spinner-border spinner-border-sm" />
                          ) : (
                            "Create Account"
                          )}
                        </Button>
                      </Form>
                    )}
                  </Formik>
                </div>

                <div className="text-center mt-4">
                  <small className="text-muted">
                    Already have an account?{" "}
                    <Link
                      to="/login"
                      className="fw-bold text-decoration-none"
                      style={{ color: "#764ba2" }}
                    >
                      Sign in
                    </Link>
                  </small>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;
